module.exports = __webpack_public_path__ + "img/outofstock.d4b2efda.jpg";